module.exports = __webpack_public_path__ + "img/imkv.70643da8.png";